import { createFileRoute, Outlet, useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'
import { useProjectsStore, type Project } from '@zendia/frontend-shared'
import { AddTwo, Search, PageInfo } from '@nine-thirty-five/material-symbols-react/rounded'
import { ActionBar } from '../../../components/ActionBar'
import { FloatingActionButton } from '../../../components/Button/FloatingActionButton'
import { ModalActionButton } from '../../../components/Modal/ModalActionButton'
import { ProjectCard } from '../../../components/Projects/ProjectCard'

export const Route = createFileRoute('/_authenticated/projects/')({
  component: ProjectsPage,
})

function ProjectsPage() {
  const { projects } = useProjectsStore()
  const router = useRouter()

  const onCreateProject = useCallback(() => {
    router.navigate({
      to: '/projects/new/form',
    })
  }, [router])

  const searchAction = () => {
    return (
      <ModalActionButton onClick={() => {}} label="Search" icon={<Search className="m-auto" />} />
    )
  }

  const optionsAction = () => {
    return (
      <ModalActionButton
        onClick={() => {}}
        label="Options"
        icon={<PageInfo className="m-auto" />}
      />
    )
  }

  const todaysDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

  return (
    <>
      <ActionBar
        startAction={searchAction()}
        title="Collections"
        subtitle={todaysDate}
        endActions={[optionsAction()]}
      />
      <div className="flex flex-col p-4">
        {projects && projects.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {projects.map((project: Project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-64 text-neutral-400">
            <div className="mb-4">No projects yet?</div>
            <button
              type="button"
              className="text-blue-500 hover:underline"
              onClick={onCreateProject}
            >
              Create Collection
            </button>
          </div>
        )}
      </div>
      <FloatingActionButton
        onClick={onCreateProject}
        className="bottom-22 sm:bottom-10 right-4 sm:right-10"
      >
        <AddTwo />
      </FloatingActionButton>
      <Outlet />
    </>
  )
}
